import { useEffect, useState } from "react";
import style from "./../../ClientBook.module.scss";
import { FaChevronRight, FaChevronUp } from "react-icons/fa";
import OptionsSelection from "./../../UI/OptionsSelection/OptionsSelection";
import StepSkeleton from "../StepSkeleton";
import DateSelection from "../../UI/DateSelection/DateSelection";
import api from "helpers/api";
import moment from "moment";

const ChooseService = ({ clinic, show, number, complete, appointment }) => {
    const defaultStaff = {
        id: null,
        label: 'Undefined'
    };
    const defaultService = {
        id: null,
        name: 'Undefined'
    }
    const [ selectedService, setSelectedService ] = useState({});
    const [ selectedOptions, setSelectedOptions ] = useState({});
    const [ selectedStaff, setSelectedStaff ] = useState(defaultStaff);
    const [ selectedDate, setSelectedDate ] = useState(null);
    const { services, staff } = clinic;

    useEffect(() => {
        if(appointment !== null) {
            setSelectedStaff([...staff, defaultStaff].find(s => s.id === appointment.staff_id));
            setSelectedService([...services, defaultService].find(s => s.id === appointment.service_id));
            setSelectedDate(moment(appointment.scheduled_at))
        }
    }, [ appointment ])

    const hasServices = () => {
        if (Array.isArray(services)) {
            return services.length > 0;
        }

        return false;
    }

    const checkAvailableTimes = async (dateRange) => {
        try {
            const res = await api.get(`/booking/verify/dates/${clinic.id}`, {
                'start_date': dateRange.start,
                'end_date': dateRange.end,
                'staff_id': selectedStaff.id,
                'minute_time_slot': 30
            })

            if (res.success && res.data.success) {
                return res.data.data;
            }
        } catch (e) {

        } finally {
        }

        return null;
    }

    const getContent = () => {
        return (
            <>
                <div className={ style.serviceGrid }>
                    { Array.isArray(services) && services.map((s, i) => {
                        return (<div onClick={ (e) => {
                            if (selectedService?.id === s.id) {
                                setSelectedService({})
                            } else {
                                setSelectedService(s)
                            }
                        } } key={ i } className={ s.id !== selectedService.id ? style.serviceCard : [ style.serviceCard, style.selected ].join(' ') }>
                            <img src={ s.icon } />
                            <h3>{ s.name }</h3>
                            <div className={ style.serviceArrow }>
                                <FaChevronRight />
                            </div>
                        </div>)
                    }) }
                </div>

                <section className={ [ style.extraOptions, (selectedService.id !== undefined || !hasServices()) && style.show ].join(' ') }>
                    { (selectedService.id !== undefined && selectedService?.options !== null && selectedService?.options !== undefined) && <div className={ style.optionGroup }>
                        { selectedService.options.map((o, i) => {
                            return (<div key={ i } className={ style.optionGroup }>
                                <OptionsSelection label={ o.title } selected={ selectedOptions[ o.id ] } options={ o.options } setSelected={ (selection) => {
                                    setSelectedOptions({ ...selectedOptions, [ o.id ]: selection })
                                } } multi={ o.multi } placeholder={ o.placeholder } />
                            </div>)
                        }) }
                    </div> }

                    <div className={ style.optionGroup }>
                        <OptionsSelection selected={ selectedStaff } options={ [
                            defaultStaff,
                            ...staff.map((s) => {
                                return {
                                    id: s.id,
                                    label: s.name
                                }
                            })
                        ] } label={ 'Choose Practinioner' } setSelected={ setSelectedStaff } />
                    </div>

                    <DateSelection dailyWorkingHoursRange={ clinic.working_hours } label={ "Choose date & time" } maxHeight={300} onChange={ setSelectedDate } checkAvailableTimes={ checkAvailableTimes } staffId={ selectedStaff.id } useDefaultTime={ appointment !== null ? true : false } dateValue={ appointment !== null && selectedDate !== null ? selectedDate : null } />
                </section>
            </>
        )
    }

    const getSummary = () => {
        return (
            <>
                { selectedService?.name } / { selectedStaff?.label } / { selectedDate !== null && selectedDate.format('MMMM DD, YYYY HH:mm') }
            </>
        )
    }

    const canContinue = () => {
        return hasServices() ? (selectedService.id === undefined || selectedDate === null ? false : true) : (selectedDate === null ? false : true);
    }

    const getData = () => {
        const serviceOptions = Object.keys(selectedOptions).length > 0 ? Object.keys(selectedOptions).map((o) => {
            return {
                'key': o,
                'value': selectedOptions[ o ].map((o) => {
                    return o.id
                })
            }
        }) : [];

        const optionsByKey = {};

        if (serviceOptions.length > 0) {
            serviceOptions.forEach((o) => {
                optionsByKey[ o.key ] = o.value;
            })
        }

        return {
            service: {
                id: selectedService.id,
                name: selectedService.name,
                icon: selectedService.icon
            },
            service_options: optionsByKey,
            staff: selectedStaff.id,
            staffName: selectedStaff.label,
            date: selectedDate.format('YYYY-MM-DD HH:mm')
        }
    }

    return (
        <StepSkeleton title="Choose Service" number={ number } show={ show } complete={ complete } getContent={ getContent } getSummary={ getSummary } getData={ getData } canContinue={ canContinue } continueLabel={ "Continue" } isCompleted={ appointment !== null ? true : undefined} />
    )
}

export default ChooseService;